import nastyConfig from 'services/config/FormatConfig.json'
let formatter; let currentCurrency; let sign
const nastyCurrency = {
  needReplace: false,
  currentToReplace: '',
}
const reg = /\d.+\d/

function init({ i18n = 'en', currency, lang }) {
  currentCurrency = currency
  const result = checkNasty()
  if (result) {
    currency = 'BRL'
  }
  formatter = new Intl.NumberFormat(i18n || lang, {
    style: 'currency',
    currency,
    currencyDisplay: 'symbol',
  })

  const sym = (currency, i18n) =>
    new Intl.NumberFormat(i18n, { style: 'currency', currency })
      .formatToParts(1)
      .find((x) => x.type === 'currency')
      .value

  sign  = sym(currency, i18n)
}

function getCurrency() {
  return sign
}

function checkNasty(){
  const config = nastyConfig
  const curReplace =  config.currencyReplace
  if(curReplace.hasOwnProperty(currentCurrency)){
    nastyCurrency.needReplace = true
    nastyCurrency.currentToReplace = curReplace[currentCurrency]
    return true
  }
  return false
}

function formatMoney(amount, decimalCount = 2, decimal = '.', thousands = ',') {
  decimalCount = Math.abs(decimalCount)
  decimalCount = isNaN(decimalCount) ? 2 : decimalCount

  let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString()
  let j = (i.length > 3) ? i.length % 3 : 0

  return (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : '')
}

function currency(value = 0, sign = true) {
  const out =  formatter.format(value / 100)
  const cur = nastyCurrency.needReplace ? `${value < 0 ? '-' : ''}${sign ? nastyCurrency.currentToReplace : ''}${formatMoney(value / 100)}` : sign ? out : checkFormat(out)

  return cur
}
function checkFormat(value){
  const format = value.match(reg)
  if(format === null || format === undefined){
    return value
  }
  else{
    return value.match(reg)[0]
  }
}

export const FormatService = {
  init,
  currency,
  getCurrency,
}
